module.exports = __webpack_public_path__ + "img/xuebitu.ae4f74e4.jpg";